/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { useAuth } from 'context/AuthContext';
import { getKPIHistory, getKPISentHistory } from 'services/dashboard.service';
import { DimGlyph } from 'components/rebrand/icons';
import { DIMENSOES, hexToRgba } from 'components/rebrand/mappings';

interface Props {
  tab: 'RECEIVED' | 'SENDED';
}

export default function Dimensions({ tab }: Props) {
  const { user, currentCycle } = useAuth();
  const [counts, setCounts] = useState<Record<string, number>>({});

  useEffect(() => {
    async function load() {
      if (!user || !currentCycle) return;

      try {
        let items: any[] = [];

        if (tab === 'RECEIVED') {
          items = await getKPIHistory(user._id, currentCycle.date_start, currentCycle.date_finish);
        } else {
          const data = await getKPISentHistory(user._id, undefined, 0, 1000, currentCycle.date_start, currentCycle.date_finish);
          items = data?.result || [];
        }

        const next: Record<string, number> = {};
        items.forEach((x: any) => {
          const valid = tab === 'RECEIVED' ? !x.cancelled : x.attributes?.status === 'OK';
          if (!valid) return;
          const behavior = tab === 'RECEIVED' ? x.behavior : x.attributes?.behavior;
          if (behavior) next[behavior] = (next[behavior] || 0) + 1;
        });
        setCounts(next);
      } catch (e) {
        setCounts({});
      }
    }

    load();
  }, [user, currentCycle, tab]);

  return (
    <div className="rb-dimensions-panel">
      <p className="rb-dimensions-panel__intro">
        Acompanhe seus reconhecimentos <strong>{tab === 'RECEIVED' ? 'recebidos' : 'enviados'}</strong> em cada{' '}
        <span className="rb-dimensions-panel__accent">dimensão da Cultura</span>.
      </p>

      <div className="rb-dimensions-panel__grid">
        {DIMENSOES.map((d, i) => (
          <div key={d.id} className="rb-dimtile rb-rise" style={{ animationDelay: `${i * 70}ms` }}>
            <div className="rb-dimtile__icon" style={{ background: hexToRgba(d.color, 0.12), boxShadow: `inset 0 0 0 2px ${d.color}` }}>
              <DimGlyph id={d.id} color={d.color} size={30} />
            </div>
            <div>
              <div className="rb-dimtile__label">{d.label}</div>
              <div className="rb-dimtile__count">
                <span className="rb-dimtile__count-value" style={{ color: d.color }}>
                  {counts[d.id] || 0}
                </span>{' '}
                recon.
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
